/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DataImportFileType = {
    _11184809: '11184809',
    draw_game: 'draw-game',
    rapid_game: 'rapid-game',
    jackpot: 'jackpot',
    draw_result: 'draw-result',
    rapid_result: 'rapid-result',
    instant_game: 'instant-game',
    location: 'location',
    winner: 'winner',
    prizes_remaining: 'prizes_remaining',
    fast_play_game: 'fast-play-game',
    fast_play_jackpot: 'fast-play-jackpot',
    fast_play_jackpot_group: 'fast-play-jackpot-group',
    rapid_jackpot: 'rapid-jackpot',
    reward_schedule: 'reward-schedule',
    draw_result_meta: 'draw-result-meta',
    s2w_game: 's2w-game',
    coupon_promotion: 'coupon-promotion',
    coupon_redemption: 'coupon-redemption',
    search_result: 'search-result',
    draw_prize_table: 'draw-prize-table',
    draw_prize_winners: 'draw-prize-winners',
    rapid_prize_table: 'rapid-prize-table',
    rapid_prize_winners: 'rapid-prize-winners',
    raffle: 'raffle',
    raffle_drawing: 'raffle-drawing',
    raffle_prize_table: 'raffle-prize-table',
    raffle_winner: 'raffle-winner',
    fast_play_prize_table: 'fast-play-prize-table',
    fast_play_prize_winners: 'fast-play-prize-winners',
    game_scoring_schema: 'game-scoring-schema',
    game_schema: 'game-schema',
    game_display_schema: 'game-display-schema',
    playslip_encoding_schema: 'playslip-encoding-schema',
    playslip_customer_settings: 'playslip-customer-settings',
    unknown_default_open_api: '11184809'
} as const;
export type DataImportFileType = typeof DataImportFileType[keyof typeof DataImportFileType];


export function instanceOfDataImportFileType(value: any): boolean {
    for (const key in DataImportFileType) {
        if (Object.prototype.hasOwnProperty.call(DataImportFileType, key)) {
            if (DataImportFileType[key as keyof typeof DataImportFileType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataImportFileTypeFromJSON(json: any): DataImportFileType {
    return DataImportFileTypeFromJSONTyped(json, false);
}

export function DataImportFileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataImportFileType {
    return json as DataImportFileType;
}

export function DataImportFileTypeToJSON(value?: DataImportFileType | null): any {
    return value as any;
}

